module.exports = __webpack_public_path__ + "img/icon-delete.f4e672a7.svg";